/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
// import { Redirect } from 'react-router-dom'
// import { withFormik } from 'formik'
// const Yup = require('yup')

/**
 *     Import
 *     - Components
 */
import Checkbox from '../../../common/Checkbox/Checkbox'
import { Button } from '../../../common/Button/Button'
import VariantionContainer from './containers/VariantionContainer'
import PopUp from '../../../common/PopUp/PopUp'

/**
 *     Import
 *     - Styles
 */
import './styles/Step05.css'

/**
 *     Step main container
 */
export default class Step05 extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            marketPopup: false,
            underwriterPopup: false,
            market: false,
            underwriter: false,
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    /**
     * Reset all quote data before going to next step
     *
     * @memberof Step05FormHTML
     */
    componentWillUnmount() {
        // if(this.props.resetQuotes){
        //     this.props.resetQuotes()
        // }
        this.props.resetQuoteVariation()
    }

    handleChangeCustom = () => { return true }

    /**
     * When user clicks on Market checkbox trigger popup
     * if the checkbox was not selected yet
     */
    clickPopupMarket = (state) => {
        if (state) {
            this.setState({ marketPopup: true, market: true })
        }
    }

    /**
     * When user clicks on OK in Market Popup
     */
    okPopupMarket = () => {
        const quoteId = this.props.editRenewal ? this.props.renewalQuoteId : this.props.match.params.id
        this.props.setAnotherMarket(quoteId)
        this.props.issueQuoteVariation(quoteId, this.state.variationsStep05[0].id)
        this.setState({ marketPopup: false, market: true })
    }

    /**
     * When user clicks CANCEL in Market Popup
     */
    cancelPopupMarket = () => this.setState({ marketPopup: false, market: false })

    /**
     * When user clicks on Market checkbox trigger popup
     * if the checkbox was not selected yet
     */
    clickPopupUnderwriter = (state) => {
        if (state) {
            this.setState({ underwriterPopup: true, underwriter: true })
        }
    }

    /**
     * When user clicks on OK in Market Popup
     */
    okPopupUnderwriter = () => {
        const quoteId = this.props.editRenewal ? this.props.renewalQuoteId : this.props.match.params.id
        this.props.setUnderwriter(quoteId)
        this.setState({ underwriterPopup: false, underwriter: true })
    }

    /**
     * When user clicks CANCEL in Market Popup
     */
    cancelPopupUnderwriter = () => this.setState({ underwriterPopup: false, underwriter: false })

    render() {

        /**
         * Check if variation have been bound
         * and if yes, redirect to summary page
         */
        // if (this.props.quote.step05.done &&
        //     this.props.quote.step05.response &&
        //     this.props.quote.step05.response.length !== 0 && this.props.editQuote) {
        //     return (<Redirect to={`/quote/${this.props.data.id}/summary`} />)
        // } else if (this.props.quote.step05.done &&
        //     this.props.quote.step05.response &&
        //     this.props.quote.step05.response.length !== 0) {
        //     return (<Redirect to={`/quote/${this.props.match.params.id}/summary`} />)
        // }

        const quoteId = this.props.editRenewal ? this.props.renewalQuoteId : this.props.match.params.id

        return (
            <div className="step05 p_zindex">
                {
                    (this.props.quote.step05.error) ?
                        < PopUp
                            title="Something went wrong"
                            buttonText="Close"
                            action={() => {
                                this.props.quote.step05.error = null
                                this.forceUpdate()
                            }}
                        >
                            {this.props.quote.step05.error.error}
                        </ PopUp>
                        :
                        null
                }
                {this.state.marketPopup ? (
                    < PopUp
                        title="Confirm"
                        buttonText="OK"
                        action={this.okPopupMarket}
                        numberButtons={2}
                        secondaryButtonText="Edit"
                        secondaryAction={this.cancelPopupMarket}
                    >
                        This will issue the current quote and refer for quoting from another market;
                        please ensure all additional cover options are selected before continuing
                    </ PopUp>
                ) : null}

                {this.state.underwriterPopup ? (
                    < PopUp
                        title="Confirm"
                        buttonText="Yes"
                        action={this.okPopupUnderwriter}
                        numberButtons={2}
                        secondaryButtonText="No"
                        secondaryAction={this.cancelPopupUnderwriter}
                    >
                        Are you sure?
                    </ PopUp>
                ) : null}

                <h4>Customise your quote</h4>
                <h5>
                    You now have the option to amend this quote.
                    You can also add two alternative options for your clients benefit.
                    Please feel free to add or delete covers, or increase or decrease the excess.
                    You can also amend your commission to fine tune the price.
                </h5>

                <div className="quote__form__group form__w100 userConfirmation">

                    {(this.props.marketStatus) ? (
                        <div className="userConfirmation__checked">
                            You've selected to quote from another market.
                            Details will be sent to you via email.
                        </div>
                    ) : (
                            <Checkbox
                                onChange={this.clickPopupMarket}
                                first={true}
                                last={this.props.underwriterStatus ? true : false}
                                selectAll={this.state.market}
                                name="check01"
                            >
                                Please tick here if you would like a quote from another market
                            </Checkbox>
                        )}

                    {(this.props.underwriterStatus) ? (
                        <div className="userConfirmation__checked">
                            You've selected to you'd like to discuss with an underwriter.
                            A member of our team will contact you soon.
                        </div>
                    ) : (
                            <Checkbox
                                onChange={this.clickPopupUnderwriter}
                                last={true}
                                first={this.props.marketStatus ? true : false}
                                selectAll={this.state.underwriter}
                                name="check02"
                            >
                                Please tick here if you would like to discuss this with an underwriter
                            </Checkbox>
                        )}

                </div>

                {(this.props.subjectivities.length !== 0) ? (

                    <div className="subjectivity">
                        <div className="subjectivity__title">
                            <span>SUBJECTIVITY WARNING:</span> If you choose
                            to bind any of these quotes, the policy will be subject to the following:
                        </div>
                        <div className="subjectivity__content">
                            {this.props.subjectivities.map((sub, i) => (
                                <div className="subjectivity__item" key={i}>
                                    <span>{sub.title}:</span> {sub.description}
                                </div>
                            ))}
                        </div>
                    </div>

                ) : null}

                <VariantionContainer
                    quoteId={parseInt(quoteId, 10)}
                    variationsStep05={
                        (variationsStep05) => this.state.variationsStep05 !== variationsStep05 ?
                            this.setState({ variationsStep05 }) :
                            null
                    }
                    dirtySteps={this.props.dirtySteps}
                    history={this.props.history}
                    editRenewal={this.props.editRenewal}
                />

                <div className="quote__form__group quote__form__group--submit">
                    <Button
                        type="submit"
                        onClick={() => this.props.history.push(`/dashboard`)}
                    >
                        Return to dashboard
                    </Button>
                </div>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step05/Step05.tsx